import { cva } from "class-variance-authority";

export const rootStyles = cva(
  [
    "relative flex items-center justify-center gap-2",
    "aspect-square outline-hidden transition-colors focus:outline-hidden",
    "bg-white",
    "border border-neutral-80",

    "disabled:cursor-not-allowed disabled:border-neutral-90 disabled:bg-neutral-95",
    "disabled:data-[state=checked]:border-neutral-90 disabled:data-[state=checked]:bg-neutral-95",
    "focus:bg-white focus:shadow-checkbox",
    "after:content-'' after:absolute after:top-0 after:left-0 after:hidden after:h-full after:w-full",
    "after:rounded-sm after:border",

    "data-[state=checked]:after:block data-[state=checked]:after:animate-ping-effect",
  ],
  {
    variants: {
      color: {
        primary: [
          "hover:border-primary-50 hover:bg-primary-95",
          "focus:border-primary-80",
          "after:border-primary-50",
          "data-[state=checked]:border-primary-50 data-[state=checked]:bg-primary-50",
        ],
        error: [
          "hover:border-error-50 hover:bg-error-95",
          "focus:border-error-80",
          "after:border-error-50",
          "data-[state=checked]:border-error-50 data-[state=checked]:bg-error-50",
        ],
      },
      size: {
        sm: "h-4 w-4 min-w-4 rounded-sm",
        md: "h-5 w-5 min-w-5 rounded-md",
      },
    },
    defaultVariants: {
      size: "sm",
      color: "primary",
    },
  }
);

export const labelStyles = cva(
  "font-semibold text-neutral-10 aria-disabled:cursor-not-allowed aria-disabled:text-neutral-80",
  {
    variants: {
      size: {
        sm: "text-sm",
        md: "text-base",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  }
);
